import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { LoaderComponent } from './components/loader/loader.component';
import { OrderByFilterPipe } from './filter/orderbyfilter';
import { CustomDirective } from './directives/custom-directive';
import { DataFilterPipe } from './filter/datafilter';
import { HighlightDirective } from './directives/highlight-directives';





@NgModule({
  declarations: [
    LoaderComponent,
    OrderByFilterPipe,
    DataFilterPipe,
    CustomDirective,
    HighlightDirective
  ],
  providers: [DatePipe],
  imports: [CommonModule],
  exports: [
    LoaderComponent,
    OrderByFilterPipe,
    DataFilterPipe,
    CustomDirective,
    HighlightDirective
  ]
})
export class SharedModule { }
